import React from 'react';

import './Upgrades.css'
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { downloadFromUrl } from './helpers';

class Upgrades extends React.Component {
  exportFile = async () => {
    const { data } = await axios.get('/api/components/export_web_upgrade_components');

    downloadFromUrl(data.url);
  }

  render() {
    return (
      <div className="upgrades-container">
        <div className="upgrades-title">Web Upgrades</div>

        <div className="upgrades-section">
          <Button className="upgrades-button" variant="info" onClick={this.exportFile}>Export</Button>
        </div>
      </div>
    );
  }
}

export default Upgrades;
